import { useState } from "react";
import { CopyIcon } from "./Icons";

export function CopyAddressButton({ address, label }: { address: string; label: string }) {
  const [status, setStatus] = useState("");

  function copy() {
    try {
      navigator.clipboard.writeText(address).then(
        () => setStatus("Copied"),
        () => setStatus(`Copy unavailable: ${address}`),
      );
    } catch {
      setStatus(`Copy unavailable: ${address}`);
    }
  }

  return <span className="copy-address-control">
    <button type="button" className="copy-address-button" aria-label={`Copy ${label}`} title={`Copy ${label}`} onClick={copy}>
      <CopyIcon />
    </button>
    {status ? <span className="copy-address-status" role="status">{status}</span> : null}
  </span>;
}
